import './auth.css';
import React, { Component } from 'react';
import { reduxForm, Field, getFormValues } from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { login, signup, initForm } from './authActions';
import Row from '../common/layout/row';
import If from '../common/operator/if';
import Messages from '../common/msg/messages';
import Input from '../common/form/inputAuth';

import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { createMuiTheme } from '@material-ui/core/styles';
import blue from '@material-ui/core/colors/blue';
import { ThemeProvider } from '@material-ui/styles';
import imagemLogo from '../assets/images/logo.png';
import backgroundLogin from '../assets/images/login_fundo.png';

class Auth extends Component {
	constructor(props) {
		super(props);
		this.state = {loginMode: true};
	}

	changeMode() {
		this.setState({ loginMode: !this.state.loginMode });
	}

	onSubmit(values) {
		const { login, signup } = this.props;
		this.state.loginMode ? login(values) : signup(values);
	}

	getStyles() {
		return makeStyles((theme) => ({
			paper: {
				marginTop: theme.spacing(8),
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center'
			},
			avatar: {
				margin: theme.spacing(1),
				backgroundColor: theme.palette.secondary.main
			},
			form: {
				width: '100%',
				marginTop: theme.spacing(1),
			},
			submit: {
				margin: theme.spacing(3, 0, 2),
			},
		}));
	}

	getTheme() {

		return createMuiTheme({
			palette: {
				primary: {
					// light: será calculada com base em palette.primary.main,
					main: '#062042',
					// dark: será calculada com base em palette.primary.main,
					// contrastText: será calculada para contrastar com palette.primary.main
				},
				secondary: {
					light: '#0066ff',
					main: '#0044ff',
					// dark: será calculada com base palette.secondary.main,
					contrastText: '#44942c',
				},
				// Usado por `getContrastText()` para maximizar o contraste entre
				// o plano de fundo e o texto.
				contrastThreshold: 3,
				// Usado pelas funções abaixo para mudança de uma cor de luminância por aproximadamente
				// dois índices dentro de sua paleta tonal.
				// Por exemplo, mude de Red 500 para Red 300 ou Red 700.
				tonalOffset: 0.2,
			},
		});
	}

	render() {

		const classes = this.getStyles();
		const { handleSubmit } = this.props;

		return (
			<ThemeProvider theme={this.getTheme()}>
				<div
					style={{
						width: '100%',
						height: '100vh',
						backgroundImage: `linear-gradient(rgba(6, 32, 66, 0.2), rgba(6, 32, 66, 0.7)), url(${backgroundLogin})`,
						backgroundSize: 'cover',
						backgroundPosition: 'center',
						backgroundRepeat: 'no-repeat',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center'
					}}
				>
					<Container
						component="main"
						maxWidth="xs"
						style={{
							width: '100%',
							textAlign: 'center'
						}}
					>
						<CssBaseline />

						<img
							src={imagemLogo}
							alt="Logo"
							style={{
								width: 350,
								marginBottom: 25,
								filter: 'drop-shadow(0 8px 18px rgba(0,0,0,.35))'
							}}
						/>

						<div
							className={classes.paper}
							style={{
								background: 'rgba(255,255,255,0.92)',
								backdropFilter: 'blur(10px)',
								WebkitBackdropFilter: 'blur(10px)',
								borderRadius: 22,
								padding: 30,
								boxShadow: '0 20px 60px rgba(0,0,0,.30)',
								border: '1px solid rgba(255,255,255,.35)'
							}}
						>
							<h2
								style={{
									margin: 0,
									marginBottom: 5,
									color: '#062042',
									fontWeight: 700
								}}
							>
								Bem-vindo
							</h2>

							<div
								style={{
									color: '#5f6b7a',
									marginBottom: 25,
									fontSize: 14
								}}
							>
								Acesse sua conta para continuar
							</div>

							<form
								className={classes.form}
								noValidate
								onSubmit={handleSubmit(v => this.onSubmit(v))}
							>
								<TextField
									variant="outlined"
									margin="normal"
									required
									fullWidth
									id="email"
									label="E-mail"
									name="email"
									type="email"
									autoFocus
									onChange={(e) =>
										this.props.initForm({
											...this.props.formularioValues,
											email: e.target.value
										})
									}
								/>

								<TextField
									variant="outlined"
									margin="normal"
									required
									fullWidth
									id="senha"
									name="senha"
									label="Senha"
									type="password"
									autoComplete="current-password"
									onChange={(e) =>
										this.props.initForm({
											...this.props.formularioValues,
											senha: e.target.value
										})
									}
								/>

								<Button
									type="submit"
									fullWidth
									variant="contained"
									style={{
										marginTop: 25,
										height: 50,
										borderRadius: 12,
										background: '#44942C',
										color: '#FFF',
										fontWeight: 600,
										fontSize: 16,
										textTransform: 'none',
										boxShadow: '0 8px 20px rgba(68,148,44,.35)'
									}}
								>
									Entrar
								</Button>
							</form>
						</div>

						<Snackbar open={this.props.message.open}>
							<MuiAlert
								severity={this.props.message.type}
								variant="filled"
							>
								{this.props.message.text}
							</MuiAlert>
						</Snackbar>
					</Container>
				</div>
			</ThemeProvider>
		);
	}
	}

Auth = reduxForm({form: 'authForm'})(Auth);
const mapStateToProps = state => ({
	message: state.auth.message,
	formularioValues: getFormValues('authForm')(state)
});
const mapDispatchToProps = dispatch => bindActionCreators({ login, signup, initForm }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Auth);
